// extracted by mini-css-extract-plugin
export default {"endsInText":"Yw3VbaRYSKV93q5xAzqB","competitionCard":"_XxyMh1a5m6BbmZ58mRA"};